import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon } from './Icons';
export function FinalCTA() {
  return <section className="py-24 px-6 lg:px-8 bg-indigo text-cream text-center relative overflow-hidden" data-id="element-74">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-full opacity-5 pointer-events-none" data-id="element-75">
        <MoonIcon className="w-full h-full" data-id="element-76" />
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-78">
          <h2 className="text-4xl md:text-5xl font-serif font-medium mb-8 leading-tight" data-id="element-79">
            ✨ Convierte la hora de dormir en un momento de paz, conexión y
            espiritualidad.
          </h2>

          <p className="text-xl text-cream/80 mb-10" data-id="element-80">
            Más de 2.300 familias ya recuperaron sus noches. Te toca a vos.
          </p>

          <a href="https://ebookpromax.online/cart/add?id=48776739487963&quantity=1" className="inline-flex flex-col items-center justify-center bg-gold text-indigo font-bold text-xl px-10 py-5 rounded-full hover:scale-105 transition-transform duration-300 shadow-lg shadow-gold/20 mb-4" data-id="element-81">
            <span data-id="element-82">✨ EMPEZAR AHORA POR $12.990 ARS</span>
          </a>

          <p className="text-cream/60 text-sm mt-4" data-id="element-83">
            7 días de garantía · Acceso inmediato
          </p>
        </motion.div>
      </div>
    </section>;
}